import { QuiBox, QuiSpinner } from '@tonicai/ui-quinine';

export function PageLoading() {
    return (
        <QuiBox display="flex" padding="lg" justifyContent="center">
            <QuiSpinner />
        </QuiBox>
    );
}
